/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiContextMenuItem } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { FunctionComponent } from 'react'

const BillingYearMenuItem: FunctionComponent<{
  year?: number
  selectedYear?: number
  onSelectBillingYear: (year?: number) => void
}> = ({ year, selectedYear, onSelectBillingYear }) => {
  const label = year || (
    <FormattedMessage id='billing-table-pagination.selected-year.all' defaultMessage='All' />
  )
  const key = year || 'all'
  const billingYear = year || undefined

  return (
    <EuiContextMenuItem
      key={key}
      icon={selectedYear === year ? 'check' : 'empty'}
      onClick={() => onSelectBillingYear(billingYear)}
    >
      {label}
    </EuiContextMenuItem>
  )
}

export default BillingYearMenuItem
